const rupiahToNumber = (value) => {
  if (!value) return 0;
  return Number(value.replace(/[^\d]/g, ""));
};

function transformChartData(rawData) {
  if (!rawData?.length) {
    return { data: [], dataKey: [] };
  }

  // Ambil semua key quarter dari API
  const quarterKeys = Object.keys(rawData[0]).filter((key) =>
    key.match(/^(y2q|y1q|yq)\d$/),
  );

  // Urutkan quarter (Y-2 → Y-1 → Y)
  quarterKeys.sort((a, b) => {
    const order = (k) => (k.startsWith("y2") ? 1 : k.startsWith("y1") ? 2 : 3);
    return order(a) - order(b) || a.localeCompare(b);
  });

  // Unique employee (nama + role)
  const employees = rawData.map((item) => ({
    name: item.employeeName,
    role: item.employeeRole,
  }));

  // Data chart per quarter
  const data = quarterKeys.map((quarter) => {
    const row = { division: quarter };

    rawData.forEach((item) => {
      row[item.employeeName] = rupiahToNumber(item[quarter]);
    });

    return row;
  });

  // dataKey: per employee, warna berdasarkan role
  const dataKey = employees.map((emp) => ({
    key: emp.name,
    color: emp.role === "MECHANIC" ? "#E53935" : "#43A047",
  }));

  return { data, dataKey };
}

export const service = {
  transformChartData,
};
